interface LoadingOverlayProps {
  show: boolean;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ show }) => {
  if (!show) {
    return null;
  }

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 10,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(255, 255, 255, 0.72)",
        color: "#2f353a",
        fontSize: "16px",
        fontWeight: 600,
      }}
    >
      <div style={{ textAlign: "center" }}>
        <i className="fa fa-spinner fa-spin fa-2x"></i>
        <div style={{ marginTop: "10px" }}>Cargando documentos...</div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
